import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useDispatch } from 'react-redux'

import { filtrosArrayBarra } from '../../../../redux/actions'
import { ESimsService } from '../../../../services/http/eSims.service'
import { useGlobal } from '../../../../stores/useGlobal'
import {
  formatArrayToString,
  formatDateToDatePicker,
  formatDateToFilter,
  formatDateToGetFilter,
  formatStringToNumberArray,
  formatStringToArray
} from '../../../../utils/genericFormatters'
import DatePicker from '../../../Mantine/DatePicker'
import Grid from '../../../Mantine/Grid'
import Modal from '../../../Mantine/Modal'
import MultiSelect from '../../../Mantine/MultiSelect'
import Select from '../../../Mantine/Select'

import * as S from './styles'

const REACT_QUERY_OPTIONS = {
  keepPreviousData: true,
  refetchOnWindowFocus: false
}
const WIDTH_COLUMNS = [6, 6, 4, 4, 4]
const PROVISIONING_STATUS_OPTIONS = [
  {
    value: '1',
    label: 'Provisionado'
  },
  {
    value: '0',
    label: 'Em branco'
  }
]

const DEFAULT_FILTERS_VALUES = {
  carriers: [],
  statuses: [],
  smdps: [],
  provisioningStatuses: null,
  lastUpdate: {
    start: null,
    end: null
  }
}

export default function FiltroESimsEstoque({ opened, close }) {
  const { filtros, setFiltros, setRevelarBarraFiltro, setIsLoadingGlobal } =
    useGlobal()
  const [filterOptions, setFilterOptions] = useState({
    carriers: [],
    statuses: [],
    smdps: [],
    provisioningStatuses: [],
    lastUpdate: {
      start: null,
      end: null
    }
  })
  const [localFilters, setLocalFilters] = useState({
    ...DEFAULT_FILTERS_VALUES
  })

  let arraySimcardFilters = []

  const despacho = useDispatch()

  useEffect(() => {
    if (!filtros.vazio) {
      const auxFilter = {
        ...DEFAULT_FILTERS_VALUES
      }

      if (filtros?.CARRIER) {
        auxFilter.carriers = formatStringToNumberArray(filtros.CARRIER)
      }

      if (filtros?.SMDPP) {
        auxFilter.smdps = formatStringToArray(filtros.SMDPP)
      }

      if (filtros?.STATUS) {
        auxFilter.statuses = formatStringToNumberArray(filtros.STATUS)
      }

      if (filtros?.PROVISIONED) {
        auxFilter.provisioningStatuses = filtros.PROVISIONED
      }

      if (filtros?.LASTUPDATESTART && filtros?.LASTUPDATEEND) {
        auxFilter.lastUpdate = {
          start: formatDateToDatePicker(filtros?.LASTUPDATESTART),
          end: formatDateToDatePicker(filtros?.LASTUPDATEEND, true, true)
        }
      }
      // eslint-disable-next-line no-console
      setLocalFilters(auxFilter)
    }
  }, [filtros])

  const { getProfilesFilter } = ESimsService

  const getFilters = async () => {
    try {
      setIsLoadingGlobal(true)
      const filtersData = await getProfilesFilter()

      setFilterOptions((prev) => ({
        ...prev,
        carriers: filtersData?.carrier?.map((item) => ({
          value: item.id,
          label: item.label
        })),
        smdps: filtersData?.smdpp?.map((item) => ({
          value: item.label,
          label: item.label
        })),
        statuses: filtersData?.profileStatus?.map((item) => ({
          value: item.id,
          label: item.label
        })),
        provisioningStatuses: PROVISIONING_STATUS_OPTIONS.map((item) => ({
          value: item.value,
          label: item.label
        }))
      }))
    } catch (error) {
      console.error('Erro ao buscar filtros de estoque de eSIMs', error)
    } finally {
      setIsLoadingGlobal(false)
    }
  }

  useQuery(['esims/stock/filters'], async () => await getFilters(), {
    ...REACT_QUERY_OPTIONS
  })

  const handleLocalFiltroChange = (fieldPath, value) => {
    const [parent, child] = fieldPath.split('.')

    setLocalFilters((prev) => {
      if (!child) {
        return {
          ...prev,
          [parent]: value
        }
      }

      return {
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: value
        }
      }
    })
  }

  const handleCleanFilters = () => {
    setLocalFilters({ ...DEFAULT_FILTERS_VALUES })
    setFiltros({ vazio: 'vazio' })
    despacho(filtrosArrayBarra([]))
    setRevelarBarraFiltro(false)
  }

  const formattedFilter = () => {
    const addFilters = (localFilterKey, filterOptionKey, prefix = '') => {
      const filteredItems = filterOptions[filterOptionKey].filter((item) =>
        localFilters[localFilterKey].includes(item.value)
      )

      const formattedItems = filteredItems.map(
        (item) => `${prefix}${item.label?.trim()} _${item.value}`
      )

      arraySimcardFilters.push(...formattedItems)
    }

    const addDateRangeFilter = (filterKey, label) => {
      const { start, end } = localFilters[filterKey] || {}
      if (start && end) {
        arraySimcardFilters.push(
          `${label}: ${formatDateToFilter(start)} e ${formatDateToFilter(end)}`
        )
      }
    }
    if (localFilters.carriers.length > 0)
      addFilters('carriers', 'carriers', 'carrierESim: ')
    if (localFilters.statuses.length > 0)
      addFilters('statuses', 'statuses', 'statusESim: ')
    if (localFilters.smdps.length > 0)
      addFilters('smdps', 'smdps', 'smdpESim: ')
    if (localFilters.provisioningStatuses) {
      arraySimcardFilters.push(
        `provisioningStatusESim: ${localFilters.provisioningStatuses == 1 ? 'Provisionado' : 'Em branco'}`
      )
    }

    addDateRangeFilter('lastUpdate', 'lastUpdateESim')

    despacho(filtrosArrayBarra(arraySimcardFilters))
  }

  const formatarValor = (value, formatter) => {
    return value && value.length ? formatter(value) : undefined
  }

  const formatarData = (value, hasHour = false, isEndOfDay = false) => {
    return value ? formatDateToGetFilter(value, hasHour, isEndOfDay) : undefined
  }

  const handleFilter = () => {
    const filteredData = {
      CARRIER: formatarValor(localFilters.carriers, formatArrayToString),
      SMDPP: formatarValor(localFilters.smdps, formatArrayToString),
      STATUS: formatarValor(localFilters.statuses, formatArrayToString),
      PROVISIONED: localFilters.provisioningStatuses || undefined,
      LASTUPDATESTART: formatarData(localFilters.lastUpdate.start),
      LASTUPDATEEND: formatarData(localFilters.lastUpdate.end, true, true)
    }

    const finalFiltros = Object.fromEntries(
      Object.entries(filteredData).filter(([, value]) => value !== undefined)
    )

    setFiltros(finalFiltros)
    setRevelarBarraFiltro(true)

    formattedFilter()
    close()
  }

  const renderFilterItems = () => {
    const items = [
      <MultiSelect
        key="carriers"
        label="Rede"
        options={filterOptions.carriers}
        value={localFilters.carriers}
        onChange={(value) => handleLocalFiltroChange('carriers', value)}
      />,
      <Select
        key="provisioningStatuses"
        label="Status de provisionamento"
        placeholder="Selecione"
        clearable={true}
        options={filterOptions.provisioningStatuses}
        value={localFilters.provisioningStatuses}
        onChange={(value) =>
          handleLocalFiltroChange('provisioningStatuses', value)
        }
      />,
      <MultiSelect
        key="smdps"
        label="SM-DP+"
        options={filterOptions.smdps}
        value={localFilters.smdps}
        onChange={(value) => handleLocalFiltroChange('smdps', value)}
      />,
      <MultiSelect
        key="statuses"
        label="Status"
        options={filterOptions.statuses}
        value={localFilters.statuses}
        onChange={(value) => handleLocalFiltroChange('statuses', value)}
      />,
      <S.FieldsWrapper key="lastUpdate">
        <DatePicker
          label="Última atualização"
          prefixo="De:"
          value={localFilters.lastUpdate.start}
          onChange={(date) => handleLocalFiltroChange('lastUpdate.start', date)}
        />
        <DatePicker
          prefixo="Até:"
          minDate={localFilters.lastUpdate.start}
          value={localFilters.lastUpdate.end}
          onChange={(date) => handleLocalFiltroChange('lastUpdate.end', date)}
        />
      </S.FieldsWrapper>
    ]

    return items
  }

  return (
    <Modal
      width="1000px"
      type="filtro"
      titulo="Filtros"
      opened={opened}
      close={close}
      onConfirm={handleFilter}
      handleCleanFilters={handleCleanFilters}
    >
      <S.Container>
        <S.Card>
          <Grid responsive colSize={WIDTH_COLUMNS}>
            {renderFilterItems()}
          </Grid>
        </S.Card>
      </S.Container>
    </Modal>
  )
}
